/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitTextFragment, SplitTextFragment, FullSplitTextFragment} from '@amblique/contentful/app/contentful/fragments/split-text';

/**
 * Get a single SplitText by ID (base - scalars only)
 */
export const getBaseSplitTextById = gql`
  ${BaseSplitTextFragment}

  query GetBaseSplitTextById($id: String!, $locale: String!, $preview: Boolean) {
    splitText(id: $id, locale: $locale, preview: $preview) {
      ...BaseSplitTextFragment
    }
  }
`;

/**
 * Get a single SplitText by ID (standard - 1 level deep)
 */
export const getSplitTextById = gql`
  ${SplitTextFragment}

  query GetSplitTextById($id: String!, $locale: String!, $preview: Boolean) {
    splitText(id: $id, locale: $locale, preview: $preview) {
      ...SplitTextFragment
    }
  }
`;

/**
 * Get a single SplitText by ID (full - 2 levels deep)
 */
export const getFullSplitTextById = gql`
  ${FullSplitTextFragment}

  query GetFullSplitTextById($id: String!, $locale: String!, $preview: Boolean) {
    splitText(id: $id, locale: $locale, preview: $preview) {
      ...FullSplitTextFragment
    }
  }
`;

/**
 * Get all SplitText entries with pagination (base - scalars only)
 */
export const getBaseSplitTexts = gql`
  ${BaseSplitTextFragment}

  query GetBaseSplitTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitTextOrder]
    $where: SplitTextFilter
    $preview: Boolean
  ) {
    splitTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSplitTextFragment
      }
    }
  }
`;

/**
 * Get all SplitText entries with pagination (standard - 1 level deep)
 */
export const getSplitTexts = gql`
  ${SplitTextFragment}

  query GetSplitTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitTextOrder]
    $where: SplitTextFilter
    $preview: Boolean
  ) {
    splitTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SplitTextFragment
      }
    }
  }
`;

/**
 * Get all SplitText entries with pagination (full - 2 levels deep)
 */
export const getFullSplitTexts = gql`
  ${FullSplitTextFragment}

  query GetFullSplitTexts(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitTextOrder]
    $where: SplitTextFilter
    $preview: Boolean
  ) {
    splitTextCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSplitTextFragment
      }
    }
  }
`;
